import { AlertCircleSolid } from "@lazarentertainment/web-design-system/components/iconSolid"
import {
  Toast,
  ToastProvider,
  ToastViewport,
} from "@lazarentertainment/web-design-system/components/toast"
import { useCartContext } from "client/packages/commerce/components/cart/CartContext"
import { useEffect, useState } from "react"

export const ToastLayer = () => {
  const { onCartEvent } = useCartContext()

  const [cartError, setCartError] = useState<string | null>(null)
  useEffect(() => {
    return onCartEvent("error", (error) => {
      setCartError(error.message)
    })
  }, [onCartEvent])

  return (
    <ToastProvider>
      <ToastViewport />
      {cartError && (
        <Toast
          data-variant="error"
          icon={AlertCircleSolid}
          toastTitle={cartError}
          duration={7000}
          onClose={() => setCartError(null)}
          // For auto-closing to work
          onOpenChange={(isOpen) => {
            if (!isOpen) {
              setCartError(null)
            }
          }}
        />
      )}
    </ToastProvider>
  )
}
